import React from 'react'
import { Box, Typography, Button } from '@mui/material'
import type { CTAAction } from '@/data/research/types'

interface CTABlockProps {
  heading: string
  body: string
  actions: CTAAction[]
  onSubscribe: () => void
  onDonate: () => void
}

const CTABlock: React.FC<CTABlockProps> = ({
  heading,
  body,
  actions,
  onSubscribe,
  onDonate,
}) => {
  return (
    <Box
      component="section"
      sx={{
        my: 6,
        p: { xs: 3, md: 4 },
        bgcolor: 'primary.main',
        color: 'primary.contrastText',
        borderRadius: 2,
        textAlign: 'center',
      }}
    >
      <Typography
        variant="h2"
        sx={{
          color: 'inherit',
          mb: 2,
          fontSize: { xs: '1.35rem', md: '2.5rem' },
        }}
      >
        {heading}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: 'inherit',
          mb: 3,
          maxWidth: 600,
          mx: 'auto',
          opacity: 0.9,
        }}
      >
        {body}
      </Typography>
      <Box
        sx={{
          display: 'flex',
          gap: 2,
          justifyContent: 'center',
          flexWrap: 'wrap',
        }}
      >
        {actions.map((action, index) => (
          <Button
            key={action.label}
            variant={index === 0 ? 'contained' : 'outlined'}
            size="large"
            onClick={action.action === 'subscribe' ? onSubscribe : onDonate}
            sx={
              index === 0
                ? {
                    bgcolor: 'secondary.main',
                    '&:hover': { bgcolor: 'secondary.dark' },
                  }
                : {
                    color: 'primary.contrastText',
                    borderColor: 'primary.contrastText',
                    '&:hover': {
                      borderColor: 'primary.contrastText',
                      bgcolor: 'rgba(255,255,255,0.1)',
                    },
                  }
            }
          >
            {action.label}
          </Button>
        ))}
      </Box>
    </Box>
  )
}

export default CTABlock
